export const API_KEY = 'AIzaSyAqsRpSGOI9PvOff4X_5rRpn5l2w990Sv4'

export default API_KEY;